module.exports = __webpack_public_path__ + "static/media/baraa.44678889.jpeg";